import { Component, Input } from '@angular/core';
import { GeneralLiabilityResponse } from '../../../../../models/api/view/claim/details/general-liability/general-liability-response';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-liability-type-gl',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    AddressLabelComponent,
  ],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
      <div class="tw-flex tw-basis-1/3 tw-gap-8 tw-flex-col">
        <app-card label="Premises">
          <app-detail-panel [dataSource]="dataSource?.premises">
            <app-detail-item label="Insured" name="insured" />
            <app-detail-item label="Type" name="type" />
          </app-detail-panel>
        </app-card>
        <app-card label="Owner">
          <app-detail-panel [dataSource]="dataSource?.owner">
            <app-detail-item label="Name" name="name" />
            <app-detail-item label="Address" name="address">
              <ng-template #value let-data>
                <app-address-label
                  [street1]="data.address"
                  [city]="data.city"
                  [state]="data.state"
                  [postalCode]="data.zip"
                  [country]="data.country === 'USA' ? null : data.country"
                />
              </ng-template>
            </app-detail-item>
            <app-detail-item label="Phone" name="phone" format="p" />
          </app-detail-panel>
        </app-card>
      </div>

      <app-card label="Product" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.product">
          <app-detail-item label="Insured" name="insured" />
          <app-detail-item label="Type" name="type" />
          <app-detail-item label="Name" name="name" />
          <app-detail-item label="Model" name="model" />
          <app-detail-item label="Serial number" name="serialNumber" />
          <app-detail-item label="Location" name="location" />
          <app-detail-item label="Other liabilities" name="otherLiabilities" />
        </app-detail-panel>
      </app-card>
      <app-card label="Manufacturer" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="dataSource?.manufacturer">
          <app-detail-item label="Name" name="name" />
          <app-detail-item label="Address" name="address">
            <ng-template #value let-data>
              <app-address-label
                [street1]="data.address"
                [city]="data.city"
                [state]="data.state"
                [postalCode]="data.zip"
                [country]="data.country === 'USA' ? null : data.country"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item label="Phone" name="phone" format="p" />
        </app-detail-panel>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class LiabilityTypeGlComponent extends BaseComponent {
  @Input() dataSource: GeneralLiabilityResponse;
}
